import {NgModule} from '@angular/core';

import {MapWrapperComponent} from "./components/map-wrapper/map-wrapper.component";
import {AppQuickFilterComponent} from "./components/app-quick-filter/app-quick-filter.component";
import {AppGraphComponent} from "./components/custom/app-graph/app-graph.component";
import {CustomTableComponent} from "./components/general/custom-table/custom-table.component";
import {MinicalendarComponent} from "./components/calendar/minicalendar/minicalendar.component";
import {SelectBarComponent} from "./components/select-bar/select-bar.component";
import {MovingAddressBoxComponent} from "./components/custom/moving-address-box/moving-address-box.component";
import {TripBoxComponent} from "./components/custom/trip-box/trip-box.component";
import {AdminFilterComponent} from "./components/custom/admin-filter/admin-filter.component";
import {AppfilterComponent} from "../../framework/components/list/appfilter/appfilter.component";
import {AdminSearchComponent} from "./components/admin-search/admin-search.component";
import {MakeReportComponent} from "./components/make-report/make-report.component";
import {PickAddressComponent} from "./components/tools/pick-address/pick-address.component";
import {HtmlEditorComponent} from "./components/tools/html-editor/html-editor.component";
import {AppEquationComponent} from "./components/tools/app-equation/app-equation.component";
import {MiniboxComponent} from "./components/view-box/minibox/minibox.component";
import {ViewFieldComponent} from "./components/view-field/view-field.component";
import {ProfileFormComponent} from "./components/profile-form/profile-form.component";
import {InsuranceCalcComponent} from "./components/general/insurance-calc/insurance-calc.component";
import {CalendarComponent} from "./components/calendar/calendar.component";
import {OneToManyComponent} from "./components/one-to-many/one-to-many.component";
import {ViewTableComponent} from './components/view-table/view-table.component';
import {ViewBoxComponent} from "./components/view-box/view-box.component";
import {AdditionalServicesComponent} from "./components/custom/additional-services/additional-services.component";
import {InventoryComponent} from "./components/custom/inventory/inventory.component";
import {CalendarWrapperComponent} from "./components/calendar/calendar-wrapper/calendar-wrapper.component";
import {RecSectionsComponent} from "./components/custom/inventory/rec-sections/rec-sections.component";
import {AdminBoxComponent} from "./components/admin-box/admin-box.component";
import {ModelTemplateComponent} from "./components/tools/model-template/model-template.component";
import {AppSignatureComponent} from "./components/tools/app-signature/app-signature.component";
import {AdminMenuComponent} from "./components/tools/admin-menu/admin-menu.component";
import {GenericModelsMenuComponent} from "./components/tools/generic-models-menu/generic-models-menu.component";
import {TableHeaderComponent} from "./components/view-table/table-header/table-header.component";
import {QuickFilterFieldComponent} from "./components/app-quick-filter/quick-filter-field/quick-filter-field.component";
import {ColumnOptionsComponent} from "./components/tools/column-options/column-options.component";
import {FieldSelectComponent} from "./components/tools/html-editor/field-select/field-select.component";
import {BoxHeaderComponent} from "./components/view-box/box-header/box-header.component";
import {AdminFooterComponent} from "./components/general/admin-footer/admin-footer.component";
import {PagesComponent} from "./components/pages/pages.component";
import {IonicModule} from "@ionic/angular";
import {ModelComponents} from "../../core/model/modelComponents";
import {AppSettings} from "../../core/conf/appSettings";
import {CommonModule, DatePipe} from "@angular/common";
import {CustomDatePipe} from "../../framework/pipes/customDate/custom-date.pipe";
import {QuillModule} from "ngx-quill";
import {ColorPickerModule} from "ngx-color-picker";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {HttpClient} from "@angular/common/http";
import {RouterModule} from "@angular/router";
import {FileUploadModule} from "ng2-file-upload";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {AppConfig} from "../../core/conf/main";
import {MenuNavComponent} from "../../core/pages/section/components/menu-nav/menu-nav.component";
import {NewOrderComponent} from "../../core/pages/order/components/new-order/new-order.component";
import {AppMapComponent} from "../../framework/components/core/app-map/app-map.component";
import {MapIconComponent} from "../../framework/components/core/map-icon/map-icon.component";
import {PagingComponent} from "../../framework/components/list/paging/paging.component";
import {
    CutPipe,
    IsLast5MinutesPipe,
    LowerCasePipe,
    NumberItPipe,
    PhoneitPipe,
    RangePipe,
    RoundPipe,
    SplitCapitalPipe
} from "../../framework/pipes/cut/cut.pipe";
import {ObjectKeysPipe} from "../../framework/pipes/object-keys/object-keys.pipe";
import {AppfileIonicComponent} from "../../framework/components/file/appfile-ionic/appfile-ionic.component";
import {AppfileWebComponent} from "../../framework/components/file/appfile-web/appfile-web.component";
import {AppfileComponent} from "../../framework/components/file/appfile/appfile.component";
import {ItemsFilterPage} from "../../core/pages/item/pages/items-filter/items-filter.page";
import {ModelAddPage} from "../../framework/pages/model-add/model-add.page";
import {AppImageUploadComponent} from "../../framework/components/general/app-image-upload/app-image-upload.component";
import {AddModelImageComponent} from "../../core/components/add-model-image/add-model-image.component";
import {VideoPlayerComponent} from "../../core/components/video-player/video-player.component";
import {ModelListPage} from "../../core/components/generic-form/components/model-list/model-list.page";
import {ItemReviewsComponent} from "../../core/pages/item/components/item-reviews/item-reviews.component";
import {DataValueComponent} from "../../core/components/data-value/data-value.component";
import {FormsModule} from "@angular/forms";
import {AppLoadingComponent} from "../../framework/components/core/app-loading/app-loading";
import {OnechatOptionComponent} from "./components/chat/onechat-option/onechat-option.component";
import {DynamicContentComponent} from "./components/tools/app-dynamic-content/app-dynamic-content.component";
import {KeyboardComponent} from "../../core/components/keyboard/keyboard.component";
import {ScrollingModule} from '@angular/cdk/scrolling';
import {
    CatalogAdminModelComponent
} from "./pages/catalog-admin/components/catalog-admin-model/catalog-admin-model.component";
import {CatalogTreeComponent} from "./pages/catalog-admin/components/catalog-tree/catalog-tree.component";
import {CatalogMenuComponent} from "./pages/catalog-admin/components/catalog-menu/catalog-menu.component";
import {AdminFieldPopupComponent} from "./components/select-bar/admin-field-popup/admin-field-popup.component";
import {CatalogManagerComponent} from "./pages/catalog-admin/catalog-manager/catalog-manager.component";
import {SectionTreeComponent} from "./pages/catalog-admin/catalog-manager/section-tree/section-tree.component";
import {ItemListComponent} from "./pages/catalog-admin/catalog-manager/item-list/item-list.component";
import {ItemDetailsComponent} from "./pages/catalog-admin/catalog-manager/item-details/item-details.component";
import {SectionBoxComponent} from "./pages/catalog-admin/catalog-manager/section-box/section-box.component";

export function HttpLoaderFactory(http: HttpClient) {
    // return new TranslateHttpLoader(http);
    let tran = new TranslateHttpLoader(http, AppConfig.assets + 'i18n/', '.json');
    return tran
}

@NgModule({
    providers: [
        ModelComponents,
        AppSettings,
        DatePipe,
        CustomDatePipe
    ],
    imports: [
        ScrollingModule,
        FormsModule,
        CommonModule,
        QuillModule.forRoot(),
        IonicModule.forRoot(),
        ColorPickerModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        RouterModule,
        FileUploadModule,
    ],
    declarations: [

        CatalogManagerComponent,
        SectionTreeComponent,
        ItemListComponent,
        ItemDetailsComponent,
        SectionBoxComponent,

        AdminFieldPopupComponent,
        CatalogMenuComponent,
        CatalogTreeComponent,
        CatalogAdminModelComponent,
        AppLoadingComponent,
        FieldSelectComponent,
        ColumnOptionsComponent,
        BoxHeaderComponent,
        TableHeaderComponent,
        GenericModelsMenuComponent,
        AdminMenuComponent,
        AppSignatureComponent,
        ModelTemplateComponent,
        AdminBoxComponent,
        AdminFooterComponent,
        MinicalendarComponent,
        CustomTableComponent,
        AppGraphComponent,
        RecSectionsComponent,
        ViewTableComponent,
        OneToManyComponent,
        ViewBoxComponent,
        ProfileFormComponent,
        InsuranceCalcComponent,
        CalendarComponent,
        ViewFieldComponent,
        SelectBarComponent,
        MovingAddressBoxComponent,
        TripBoxComponent,
        PagesComponent,
        AppfilterComponent, AdminFilterComponent,
        AdminSearchComponent,
        MakeReportComponent,
        AppEquationComponent,
        HtmlEditorComponent,
        MiniboxComponent,
        InventoryComponent,
        PickAddressComponent,
        AdditionalServicesComponent,
        CalendarWrapperComponent,
        MapWrapperComponent,
        AppQuickFilterComponent,
        QuickFilterFieldComponent,

        MenuNavComponent,
        NewOrderComponent,
        AppMapComponent,
        MapIconComponent,
        PagingComponent,
        IsLast5MinutesPipe,
        PhoneitPipe,
        NumberItPipe,
        CutPipe,
        SplitCapitalPipe,
        LowerCasePipe,
        RangePipe,
        ObjectKeysPipe,
        RoundPipe,
        CustomDatePipe,
        AppfileIonicComponent,
        AppfileWebComponent,
        AppfileComponent,
        ItemsFilterPage,
        ModelAddPage,
        AppImageUploadComponent,
        AddModelImageComponent,
        VideoPlayerComponent,
        AppfilterComponent,
        ModelListPage,
        ItemReviewsComponent,
        DataValueComponent,
        OnechatOptionComponent, DynamicContentComponent
    ],
    exports: [

        CatalogManagerComponent,
        SectionTreeComponent,
        ItemListComponent,
        ItemDetailsComponent,
        SectionBoxComponent,

        AdminFieldPopupComponent,
        ScrollingModule,
        CatalogMenuComponent,
        CatalogTreeComponent,
        AppLoadingComponent,
        FieldSelectComponent,
        ColumnOptionsComponent,
        BoxHeaderComponent,
        TableHeaderComponent,
        GenericModelsMenuComponent,
        AdminMenuComponent,
        AppSignatureComponent,
        ModelTemplateComponent,
        PagesComponent,
        AdminBoxComponent,
        AdminFooterComponent,
        MinicalendarComponent,
        CustomTableComponent,
        AppGraphComponent,
        RecSectionsComponent,
        ViewTableComponent,
        ViewBoxComponent,
        ProfileFormComponent,
        InsuranceCalcComponent,
        OneToManyComponent,
        CalendarComponent,
        ViewFieldComponent,
        SelectBarComponent,
        MovingAddressBoxComponent,
        TripBoxComponent,
        AppfilterComponent, AdminFilterComponent,
        AdminSearchComponent,
        MakeReportComponent,
        HtmlEditorComponent,
        MiniboxComponent,
        AppEquationComponent,
        PickAddressComponent,
        InventoryComponent,
        AdditionalServicesComponent,
        CalendarWrapperComponent,
        MapWrapperComponent,
        AppQuickFilterComponent,
        AppGraphComponent,
        QuickFilterFieldComponent,

        MenuNavComponent,
        AppMapComponent,
        MapIconComponent,
        TranslateModule,
        IsLast5MinutesPipe,
        CutPipe,
        PhoneitPipe,
        NumberItPipe,
        SplitCapitalPipe,
        LowerCasePipe,
        RangePipe,
        ObjectKeysPipe,
        RoundPipe,
        CustomDatePipe,
        AppImageUploadComponent,
        AddModelImageComponent,
        VideoPlayerComponent,
        OnechatOptionComponent, DynamicContentComponent, CatalogAdminModelComponent,

    ]
})
export class AdminGlobalModule {
}


export interface ResObject {
    models?: any;
    data?: any;
}

export interface CostumRes {
    res?: any;
}

export interface ModelObject {
    data?: ResData;
}

interface ResData {
    id?: object;
}

export interface FieldDataObject {
    calFunc?: any,
    selfTemplate?: any,
    readonly?: boolean,
    displayField?: string,
    type?: any,
    oneToOne?: any,
    extFieldName?: any,
    price?: any,
    nis?: any,
    precents?: any,
    addText?: any,
    modelDataKey?: any,
    selectMultiple?: boolean,
    title?: any,
    height?: any,
    min?: any
    addParams?: any,
    maxlength?: any,
    minlength?: any,
    bigarea?: boolean,
    editTemplate?: any,
    defaultValue?: any
}